<template>
  <div>
    <headNavBar title="会员密码修改" />

    <van-field
      label="原密码"
      type="password"
      placeholder="请输入原密码"
      v-model="oldPassword"
    />
    <van-field
      label="新密码"
      type="password"
      placeholder="请输入新密码"
      v-model="newPassword"
    />
    <van-button
      type="info"
      size="large"
      style="margin:0.5rem 3%;font-size:0.5rem;width:94%;"
      @click="changePassword"
      :loading="buttonLoading"
      >确认修改</van-button
    >
  </div>
</template>

<script>
import { Field, Button, Notify, Toast } from "vant";
import { memberPasswordUpdate } from "@/api/member.js";
import { mapState } from "vuex";
import md5 from "js-md5";
export default {
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      buttonLoading: false,
    };
  },
  computed: {
    ...mapState({
      info: state => state.user.info,
    }),
  },
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Notify.name]: Notify,
  },
  created() {},
  methods: {
    changePassword() {
      this.buttonLoading = true;
      const id = this.$route.query.Id;
      let oldPass = this.oldPassword;
      if (this.oldPassword.trim() != "") {
        oldPass = md5(this.oldPassword.trim());
      }
      this.newPassword = this.newPassword.trim();
      let params = {
        MemberCardId: id,
        IsReset: false,
        OldPassword: oldPass,
        NewPassword: this.newPassword,
      };
      memberPasswordUpdate(params)
        .then(() => {
          Toast.success("修改成功");
          this.buttonLoading = false;
          this.$router.push({
            name: "memberInfo",
            query: {
              Id: id,
            },
          });
        })
        .catch(() => {
          this.buttonLoading = false;
        });
    },
  },
};
</script>
